import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-viewed-by',
  standalone: true,
  imports: [],
  templateUrl: './process-viewed-by.component.html',
  styles: ``
})
export class ProcessViewedByComponent {
  @Input() process!: Process;
}
